// whitelabel/sakformasihotels.js

export default {
  brandId: 'sakformasihotels',
  name: 'Masi Hotels',
  tagline: {
    it: "Benessere e ospitalità sul Lago di Bolsena",
    en: "Wellness and hospitality on Lake Bolsena"
  },
  logoSAK: '/logo-sak-pointer-with-text-horizontal.png',
  logo: '/logo-sak-and-masi.png',
  secondaryLogo: '/logo-rent-a-bike-and-experiences.png', // Rent a bike logo
  logoLongText: '/logo-for-masi-hotels.png', // Logo with text and "For"
  secondaryLogoLongText: '/logo-sak-pointer-with-text-horizontal.png', // Smart AppKey logo with horizontal text
  colors: {
    primary: '#193441',        // 🟦 Main text color, often used for titles or key headings
    secondary: '#F2F2F2',      // ⬜️ Light gray background for cards, inputs, or sections
    accent: '#5A8160',         // It’s a muted sage/olive green, giving an earthy, natural vibe.
    background: '#FFFFFF',     // ⚪️ Default page background
    explore: '#B56CC3',        // 🟪 Soft purple accent — used for primary actions like "Login" or "Save"
    appKeyGreen: '#31D33A',    // 🟢 Smart AppKey branding green (used in taglines/logos)
  },
  mapCenter: [11.991, 42.645]
};
